/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './Link.scss';
import { appLinkSize, appLinkStyle, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import Icons from '@core/Utils/Icons/Icons';

export function Link({
  children = null,
  iconLeft = null,
  iconRight = null,
  label,
  linkStyle = appLinkStyle.PRIMARY,
  linkSize = appLinkSize.DEFAULT,
  isLoading = false,
  href,
  onClick = () => {},
  ...restProps
}) {
  const linkIconLeft = getKeyByValue(appIconsPath,iconLeft);
  const linkIconRight = getKeyByValue(appIconsPath,iconRight);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.code === 'Space') {
      e.preventDefault();
      if (href) {
        window.open(href, '_blank');
      } else {
        onClick();
      }
    }
  };

  return (
    <a
      className={`ek-link ${linkStyle} ${linkSize} border-0 bg-transparent d-inline-block`}
      href={href}
      target="_blank"
      rel="noreferrer"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      {...restProps}>
      {isLoading ? (
        <>
          <span className="w-100 py-2 d-inline-flex align-items-center justify-content-center">
            <span
              style={{ width: '20px', height: '20px' }}
              className="spinner-border spinner-border-sm"
              role="status"
            />
          </span>
        </>
      ) : (
        <span className="d-flex align-items-center justify-content-start">
          {iconLeft && <Icons name={linkIconLeft} height={16} colorType='dark' className="link-icon pe-8" />}
          {label &&
            (tA11y(label).isHtml ? (
              <span
                className="link-label"
                dangerouslySetInnerHTML={{ __html: sanitizeRichText(tA11y(label).content) }}
              />
            ) : (
              <span className="link-label">{tA11y(label).content}</span>
            ))}
          {children && <span className="link-children">{children}</span>}
          {iconRight && <Icons name={linkIconRight} height={16} colorType='dark' className="link-icon ps-4" />}
        </span>
      )}
    </a>
  );
}

Link.propTypes = {
  children: PropTypes.node,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  label: PropTypes.string,
  linkStyle: PropTypes.string,
  linkSize: PropTypes.string,
  isLoading: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func
};

export default Link;
